import { collection, doc, getDocs, query, updateDoc, where, getDoc, addDoc, deleteDoc } from "firebase/firestore";
import { db, storage } from "../Config/Firebase-config";
import { getUserDocId } from "../../Localstorage";
import { getDownloadURL, uploadBytes, ref } from "firebase/storage";

// LATER ON IT WILL DELETE 

export const getAllUsers = async () => {
  const usersCol = collection(db, "student");
  const userSnapshot = await getDocs(usersCol);
  const userList = userSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
  resetDeviceCount()
  console.log(userList);
};

const resetDeviceCount = async () => {
  const usersCol = collection(db, "student"); // replace "users" with your actual collection name
  const snapshot = await getDocs(usersCol);

  const updatePromises = [];

  snapshot.forEach((document) => {
    const data = document.data();
      const docRef = doc(db, "student", document.id);
      updatePromises.push(updateDoc(docRef, { device_count: 0 })); // or update other fields
  });

  await Promise.all(updatePromises);
  console.log("All matching documents updated.");
};

// export const deleteUserByPhone = async (phoneNumber) => {
//   try {
//     const q = query(collection(db, "student"), where("mobile_number", "==", phoneNumber));
//     const querySnapshot = await getDocs(q);

//     if (querySnapshot.empty) {
//       console.warn("No user found with this phone number.");
//       return false;
//     }
//     for (const document of querySnapshot.docs) {
//       await deleteDoc(doc(db, "student", document.id));
//       console.log(`Deleted user with ID: ${document.id}`);
//     }

//     return true;
//   } catch (error) {
//     console.error("Error deleting user by phone:", error.message);
//     return false;
//   }
// };

// LATER ON IT WILL DELETE 


export const RegisterUser = async (user) => {
  try {
    const docRef = await addDoc(collection(db, "student"), user);
    return [
      {
        id: docRef.id,
        ...user
      }
    ];
  } catch (error) {
    console.error("Error saving user:", error.message);
    return null;
  }
};

export const loginUser = async (phone_number) => {
  try {
    const querry = query(collection(db, "student"),
      where("mobile_number", "==", phone_number.mobile_number));
    const querySnapshot = await getDocs(querry);
    const loginUser = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return loginUser;
  } catch (error) {
    console.error(error.message);
  }
}

export const getUserData = async (user) => {
  try {
    const userDoc = await getDoc(doc(db, "student", user.id));
    const firestoreSessionId = userDoc.data()?.device_count;
    return firestoreSessionId;
  } catch (error) {
    console.error(error.message)
  }
}

export const updateDeviceCount = async (userData, sessionId,milisec) => {
  await updateDoc(doc(db, "student", userData[0].id), {
    device_count: sessionId
  });
}

export const updateTimeStamp = async (userData,milisec) => {
  await updateDoc(doc(db, "student", userData[0].id), {
    lastTimeStamp:milisec
  });
}

export const fetchTeacher = async () => {
  try {
    const querry = query(collection(db, "teachers"));
    const querySnapshot = await getDocs(querry);
    const teacher = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return teacher;
  } catch (error) {
    console.error(error.message);
  }
}

export const updateUserData = async (docId, updatedData) => {
  try {
    console.log(updatedData)
    const userRef = doc(db, "student", docId);
    await updateDoc(userRef, updatedData);
    console.log("Document updated successfully");
    return true
  } catch (error) {
    console.error("Error updating document:", error);
    return false
  }
};

export const fetchStudentData = async (docId) => {
  try {
    const studentRef = doc(db, "student", docId); // 'student' is the collection name
    const studentSnap = await getDoc(studentRef);

    if (studentSnap.exists()) {
      return { id: studentSnap.id, ...studentSnap.data() };
    } else {
      console.log("No such document!");
      return null;
    }
  } catch (error) {
    console.error("Error fetching student data:", error);
    return null;
  }
};

export const fetchDownloadImg = async (file) => {
  try {
    const student_docId = getUserDocId();
    const storageRef = ref(storage, `images/${student_docId}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);

    return downloadURL;
  } catch (error) {
    console.error("Image upload error:", error.message);
  }
}